$(document).ready(function() {

    if ($.fn.summernote) {
        // Submit the actual markup from Summernote
        $('input[type="submit"]').click(function (e) {
            e.preventDefault();
            if ($(this.form).has('textarea.summernote')) {
                $(this.form).find('.summernote').each(function (index) {
                    var descMarkup = $(this).summernote('code');
                    this.innerHTML = descMarkup;
                });
            }
            $(this.form).submit();
        });
    }

    // Default Template for new NAtional Initiatives.
    if($('#initiative-public-content').length > 0){
        var markupStr = '' +
            '<!-- NOTE ABOUT TEMPLATE -->\n' +
            '<!-- PLEASE REMOVE EVERYTHING BETWEEN THE "NOTE ABOUT TEMPLATE" LINES BEFORE PUBLISHING!!! -->\n\n' +
            '<hr style="margin:0;border-top:solid 3px;"><hr style="margin:1px 0;border-top:dashed 3px;"><hr style="margin:0;border-top:solid 3px;">\n\n' +
            '<div class="well"> Below is a template with some of the layout, structures and styles that are used on the front-end of the website for National Initiatives. To use these, simply edit the content below! You can also select portions, and copy/paste them to increase the number of sections/bullets/etc.  If you are familiar with HTML, you can also click the last button in the toolbar above [&lt;/&gt;] and the editor will switch to the raw HTML code.</div>\n\n' +
            '<hr style="margin:0;border-top:solid 3px;"><hr style="margin:1px 0;border-top:dashed 3px;"><hr style="margin:0;border-top:solid 3px;">\n' +
            '<!-- NOTE ABOUT TEMPLATE -->\n\n\n' +
            '<div class="about">\n' +
            '<h6 class="title lead">\n' +
            '    National Initiative #:  Improving Community Health and Health Equity through...\n' +
            '</h6>\n' +
            '<h2 class="title" style="color: #72bf44;">\n' +
            '    AIAMC NATIONAL INITIATIVE #: YearStart - YearEnd\n' +
            '</h2>\n' +
            '*** COPY SECTION 1 ***' +
            '<section class="about-section">\n' +
            '    <p class="section-title">\n' +
            '        National Initiative Section 1 Header\n' +
            '        <i class="fa fa-plus"></i>\n' +
            '    </p>\n' +
            '    <div class="content">\n' +
            '        <p>\n' +
            '            Section 1 Content. Any content that belongs to the section heading above can go here.\n' +
            '        </p>\n' +
            '    </div>\n' +
            '</section>\n' +
            '*** COPY SECTION 1 ***' +
            '\n<br>\n' +
            '*** COPY SECTION 2***' +
            '<section class="about-section">\n' +
            '    <p class="section-title">\n' +
            '        National Initiative Section 2 Header\n' +
            '        <i class="fa fa-plus"></i>\n' +
            '    </p>\n' +
            '    <div class="content">\n' +
            '        <p>\n' +
            '            Section 2 Content. This section contains a paragraph and a bullet-list.\n' +
            '        </p>\n' +
            '        <ul>\n' +
            '            <li>List Item</li>\n' +
            '            <li><a href="#">List Item Link</a></li>\n' +
            '            <li><a href="#" target="_blank">List Item Link (Opens in New Tab)</a></li>\n' +
            '        </ul>\n' +
            '    </div>\n' +
            '</section>' +
            '</div>\n' +
            '*** COPY SECTION 2***';
        $('head').append('<link rel="stylesheet" type="text/css" href="/css/app-frontend.css">');
        $('#initiative-public-content').summernote('code', markupStr);
    }

});